import {AbstractDTO} from '../../dto/abstract';

export class DriveItem extends AbstractDTO {
    name: string;
    createBy: string;
    creationTimestamp: Date;
    fileSize: string;
    type: string;
}
